export default __webpack_public_path__ + "static/media/documentuploadicon.c02b23f6.png";